import React from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import moment from 'moment';

const DonationDetailsModal = ({ item }) => {
  return (
    <>
      <ModalHeader className="bg-primary text-white">
        Donation Details
      </ModalHeader>
      <ModalBody>
        <div className="p-4 border rounded">
          <div className="row row-cols-1 row-cols-md-2 g-4">
            {/* Donor Information */}
            <div className="col">
              <h5 className="text-primary mb-3">Donor Information</h5>
              <div className="mb-2">
                <strong>Name:</strong> {item?.full_name}
              </div>
              <div className="mb-2">
                <strong>Email:</strong> {item?.email_address}
              </div>
              <div className="mb-2">
                <strong>Payer ID:</strong> {item?.payer_id}
              </div>
              <div className="mb-2">
                <strong>Amount:</strong>{" "}
                <span className="text-success">
                  {item?.amount} {item?.currency_code}
                </span>
              </div>
              <div className="mb-2">
                <strong>Payment Date:</strong>{" "}
                {moment(item?.response?.create_time).format(
                  "DD-MM-YYYY HH:mm:ss"
                )}
              </div>
              <div className="mb-2">
                <strong>Update Time:</strong>{" "}
                {moment(item?.response?.update_time).format(
                  "DD-MM-YYYY HH:mm:ss"
                )}
              </div>
            </div>

            {/* Payment Details */}
            <div className="col">
              <h5 className="text-primary mb-3">Payment Details</h5>
              <div className="mb-2">
                <strong>Transaction ID:</strong>{" "}
                <span className="text-break">{item?.id}</span>
              </div>
              <div className="mb-2">
                <strong>Merchant ID:</strong>{" "}
                <span className="text-break">
                  {item?.merchantID}
                </span>
              </div>
              <div className="mb-2">
                <strong>Status:</strong>{" "}
                <span
                  className={`badge bg-${item?.status === "COMPLETED"
                      ? "success"
                      : "warning"
                    }`}
                >
                  {item?.status}
                </span>
              </div>
              <div className="mb-2">
                <strong>Intent:</strong> {item?.response?.intent}
              </div>
              <div className="mb-2">
                <strong>Payee Email:</strong>{" "}
                <span className="text-break">
                  {
                    item?.response?.purchase_units?.[0]?.payee
                      ?.email_address
                  }
                </span>
              </div>
            </div>
          </div>

          {/* Capture Details */}
          {item?.response?.purchase_units?.[0]?.payments
            ?.captures && (
              <div className="row">
                <div className="col-12">
                  <h5 className="text-primary mt-4 mb-3">
                    Capture Details
                  </h5>
                  {item.response.purchase_units[0].payments.captures.map(
                    (capture, index) => (
                      <div key={index} className="mb-3 p-2 border rounded">
                        <div>
                          <strong>Capture ID:</strong> {capture.id}
                        </div>
                        <div>
                          <strong>Status:</strong> {capture.status}
                        </div>
                        <div>
                          <strong>Amount:</strong> {capture.amount.value}{" "}
                          {capture.amount.currency_code}
                        </div>
                        <div>
                          <strong>Create Time:</strong>{" "}
                          {moment(capture.create_time).format(
                            "DD-MM-YYYY HH:mm:ss"
                          )}
                        </div>
                      </div>
                    )
                  )}
                </div>
              </div>
            )}
        </div>
      </ModalBody>
    </>
  );
};

export default DonationDetailsModal; 